import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';

interface IVin {
  vin?: string;
}

const Vin: FC<IVin> = observer(({ vin }) => {
  if (!vin) return null;

  return (
    <tr>
      <td className="pale">VIN</td>
      <td>
        <span className="bold">{vin}</span>
      </td>
    </tr>
  );
});

export default Vin;
